import React, { useState } from "react";
import Img from "gatsby-image";
import styled from "styled-components";
import richText from "../utils/richText";
import { Colors } from "./styles/Colors";
import { Header4, Body, ProximaNova } from "./typography";
import { PrimaryButton } from "./Button";
import Breakpoints from "./styles/Breakpoints";

const Button = styled.button`
  cursor: pointer;

  position: relative;

  background: none;

  color: ${Colors.cream1};
  border: 1px solid ${Colors.cream2};

  font-family: ${ProximaNova};
  font-size: 12px;

  text-transform: uppercase;
  letter-spacing: 0.15em;

  padding: 14px 42px 14px 16px;

  margin: 16px 0;

  > svg {
    position: absolute;

    width: 18px;
    height: 18px;

    top: 50%;
    right: 12px;

    transform: translateY(-50%);
  }

  &:hover {
    background: ${Colors.cream2};
    color: ${Colors.sage};

    > svg {
      .icon-bg {
        fill: ${Colors.hunter};
      }

      .plus-sign {
        stroke: ${Colors.white};
      }
    }
  }
`;

const Overlay = styled.div`
  position: fixed;

  width: 100%;
  height: 100%;

  top: 0;
  left: 0;

  background: ${Colors.grey};
  opacity: 0.6;
  z-index: 10;
`;

const Image = styled.div`
  height: 240px;
  width: 100%;

  > div {
    height: 100%;
  }

  @media ${Breakpoints.tablet} {
    width: 33%;
    height: 100%;

    flex: 1 1 40%;
  }
`;

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  position: fixed;

  top: 50%;
  left: 50%;

  width: 90%;
  height: 95%;

  max-width: 980px;
  max-height: 480px;

  z-index: 11;

  background: ${Colors.cream2};

  color: ${Colors.grey};

  transform: translate(-50%, -50%);

  overflow-y: auto;

  > div:last-child {
    overflow-y: auto;

    padding: 32px;

    ${Header4} {
      margin-bottom: 16px;
      color: ${Colors.hunter};
    }

    ${Body} {
      color: ${Colors.greyLight};
    }
  }

  @media ${Breakpoints.tablet} {
    flex-direction: row;

    > div:last-child {
      flex: 1 1 60%;

      display: flex;
      flex-direction: column;
      justify-content: center;

      padding: 0 80px;

      ${PrimaryButton} {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 60px;
        background: none;
        color: ${Colors.hunter};

        font-family: ${ProximaNova};
        font-size: 12px;
        text-transform: uppercase;

        margin: 0;
        padding: 0;

        height: auto;
      }
    }
  }
`;

const CloseButton = styled(PrimaryButton)`
  margin-top: 40px;
`;

export default function IngredientsModal({ ingredients, image }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        View Ingredients
        <svg
          width="18"
          height="18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="icon-bg"
            d="M9 16.5c4.1421 0 7.5-3.3579 7.5-7.5S13.1421 1.5 9 1.5 1.5 4.8579 1.5 9s3.3579 7.5 7.5 7.5z"
            fill="#F6F4F1"
          />
          <path
            className="plus-sign"
            d="M9 6v6"
            stroke="#445F63"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            className="plus-sign"
            d="M6 9h6"
            stroke="#445F63"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            className="plus-sign"
            d="M6 9h6"
            stroke="#445F63"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
      {open && (
        <>
          <Modal>
            <Image>
              <Img fluid={image} />
            </Image>
            <div>
              <Header4>Ingredients</Header4>
              <div>{richText(ingredients.raw)}</div>
              <CloseButton onClick={() => setOpen(false)}>Close</CloseButton>
            </div>
          </Modal>
          <Overlay onClick={() => setOpen(false)} />
        </>
      )}
    </>
  );
}
